import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../common/layout/layout.module'

import { MyDocumentsRoutingModule } from './my-documents-routing.module';
import { MyDocumentsComponent } from './my-documents/my-documents.component';
import { SharedModule } from '../../common/shared/shared.module';
import { MyDocumentsListComponent } from './my-documents-list/my-documents-list.component';
import { MyDocumentsUploadComponent } from './my-documents-upload/my-documents-upload.component';
import { MyDocumentsFileUploadComponent } from './my-documents-file-upload/my-documents-file-upload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const declarations = [
    MyDocumentsComponent,
    MyDocumentsListComponent,
    MyDocumentsUploadComponent,
    MyDocumentsFileUploadComponent,
];

@NgModule({
    declarations: [
        ...declarations,
    ],
  imports: [
    CommonModule,
    MyDocumentsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule
  ]
})
export class MyDocumentsModule { }
